/**
 * README generator for exported sites
 */

export function generateReadme(settings: any, assetsCount = 0): string {
  const date = new Date().toLocaleDateString('de-CH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const assetsLine = assetsCount
    ? `/assets/             - Exportierte Bilder (${assetsCount} Datei(en))\n`
    : '';

  return `================================================
${settings.siteName || 'Website'}
================================================

Erstellt am: ${date}
Generator: Studio v5.0.0

DATEISTRUKTUR
-------------
/index.html          - Startseite
/impressum.html      - Impressum (falls aktiviert)
/datenschutz.html    - Datenschutz (falls aktiviert)
/angebot.html        - Angebot/Preise (falls aktiviert)
/methoden.html       - Methodik/Arbeitsweise (falls aktiviert)
/ueber-mich.html     - \u00dcber mich/\u00dcber uns (falls aktiviert)
/offerte-generator.html - Offerte Tool (standalone)
/backup.json         - Projekt-Backup (Import/Restore)
${assetsLine}/css/tokens.css      - Design Tokens (Farben, Abst\u00e4nde, etc.)
/css/components.css  - Komponenten-Styles
/js/main.js          - JavaScript (Men\u00fc, Scroll, Consent)

DEPLOYMENT
----------
1. Alle Dateien auf Ihren Webserver hochladen
2. Fertig! Keine Konfiguration n\u00f6tig.

ANPASSUNGEN
-----------
- Farben & Tokens: /css/tokens.css (CSS-Variablen am Anfang)
- Texte: Direkt in den HTML-Dateien
- Styles: /css/components.css
- Rechtstexte: impressum.html / datenschutz.html (falls aktiviert)

HINWEIS ZU TRACKING & CONSENT
-----------------------------
Tracking-Skripte werden (falls konfiguriert) standardm\u00e4ssig "geparkt" exportiert
und d\u00fcrfen erst nach Einwilligung laden. Pr\u00fcfen Sie das Consent-Setup vor Livegang.

SUPPORT
-------
Diese Website wurde mit Studio erstellt.
Bei Fragen wenden Sie sich an Ihren Webdesigner.

================================================
`;
}
